import React, { useState } from 'react';
import EmployeeDetailModal from './EmployeeDetailModal';

const DirectoryPage = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedDepartment, setSelectedDepartment] = useState('Tümü');
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const departments = ['Tümü', 'Ulaştırma Projeleri', 'Enerji Projeleri', 'İnsan Kaynakları', 'Teknik Ofis', 'Satın Alma'];

  const employeesData = [
    {
      id: 1,
      name: "Ahmet Yılmaz",
      title: "Proje Müdürü",
      department: "Ulaştırma Projeleri",
      email: "ahmet.yilmaz@kolin.com.tr",
      phone: "+90 532 123 4567",
      location: "İstanbul",
      avatar: "https://placehold.co/120x120/3C21F7/FFFFFF?text=AY&font=poppins"
    },
    {
      id: 2,
      name: "Elif Güneş",
      title: "İnsan Kaynakları Uzmanı",
      department: "İnsan Kaynakları",
      email: "elif.gunes@kolin.com.tr",
      phone: "+90 532 234 5678",
      location: "Ankara",
      avatar: "https://placehold.co/120x120/00BC39/FFFFFF?text=EG&font=poppins"
    },
    {
      id: 3,
      name: "Bora Çelik",
      title: "Saha Mühendisi",
      department: "Enerji Projeleri",
      email: "bora.celik@kolin.com.tr",
      phone: "+90 532 345 6789",
      location: "İzmir",
      avatar: "https://placehold.co/120x120/FFBB00/FFFFFF?text=BÇ&font=poppins"
    },
    {
      id: 4,
      name: "Zeynep Kaya",
      title: "Teknik Ressam",
      department: "Teknik Ofis",
      email: "zeynep.kaya@kolin.com.tr",
      phone: "+90 532 456 7890",
      location: "İstanbul",
      avatar: "https://placehold.co/120x120/DC3545/FFFFFF?text=MK&font=poppins"
    },
    {
      id: 5,
      name: "Mustafa Demir",
      title: "Satın Alma Uzmanı",
      department: "Satın Alma",
      email: "mustafa.demir@kolin.com.tr",
      phone: "+90 532 567 8901",
      location: "Bursa",
      avatar: "https://placehold.co/120x120/17A2B8/FFFFFF?text=SA&font=poppins"
    },
    {
      id: 6,
      name: "Ayşe Kurtuluş",
      title: "Proje Müdürü",
      department: "Ulaştırma Projeleri",
      email: "ayse.kurtulus@kolin.com.tr",
      phone: "+90 532 678 9012",
      location: "Ankara",
      avatar: "https://placehold.co/120x120/6C757D/FFFFFF?text=FD&font=poppins"
    },
    {
      id: 7,
      name: "Fatih Sönmez",
      title: "İnşaat Mühendisi",
      department: "Enerji Projeleri",
      email: "fatih.sonmez@kolin.com.tr",
      phone: "+90 532 789 0123",
      location: "Adana",
      avatar: "https://placehold.co/120x120/28A745/FFFFFF?text=ZT&font=poppins"
    },
    {
      id: 8,
      name: "Can Tekin",
      title: "AR-GE Uzmanı",
      department: "Teknik Ofis",
      email: "can.tekin@kolin.com.tr",
      phone: "+90 532 890 1234",
      location: "İstanbul",
      avatar: "https://placehold.co/120x120/FFC107/000000?text=ES&font=poppins"
    }
  ];

  const filteredEmployees = employeesData.filter(employee => {
    const matchesSearch = employee.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
                         employee.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
                         employee.department.toLowerCase().includes(searchQuery.toLowerCase());
    
    const matchesDepartment = selectedDepartment === 'Tümü' || employee.department === selectedDepartment;
    
    return matchesSearch && matchesDepartment;
  });

  return (
    <div className="directory-page">
      <div className="row mb-4">
        <div className="col-12">
          <div className="box">
            <div className="box-header">
              <h3 className="mb-0">Personel Rehberi</h3>
              <p className="text-muted">Şirket çalışanlarının iletişim bilgileri</p>
            </div>
          </div>
        </div>
      </div>

      {/* Search and Filter */}
      <div className="row mb-4">
        <div className="col-md-8 col-sm-12 mb-3">
          <div className="box">
            <div className="box-body">
              <div className="input-group">
                <span className="input-group-text">
                  <i className="bx bx-search"></i>
                </span>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Çalışan Ara (İsim, Departman, Unvan...)"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
              </div>
            </div>
          </div>
        </div>
        
        <div className="col-md-4 col-sm-12 mb-3">
          <div className="box">
            <div className="box-body">
              <select 
                className="form-select"
                value={selectedDepartment}
                onChange={(e) => setSelectedDepartment(e.target.value)}
              >
                {departments.map(dept => (
                  <option key={dept} value={dept}>{dept}</option>
                ))}
              </select>
            </div>
          </div>
        </div>
      </div>

      {/* Results Count */}
      <div className="row mb-3">
        <div className="col-12">
          <div className="d-flex justify-content-between align-items-center">
            <p className="text-muted mb-0">
              {filteredEmployees.length} çalışan bulundu
            </p>
            <div className="btn-group btn-group-sm" role="group">
              <button type="button" className="btn btn-outline-secondary active">
                <i className="bx bx-grid-alt"></i>
              </button>
              <button type="button" className="btn btn-outline-secondary">
                <i className="bx bx-list-ul"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Employee Cards */}
      <div className="row">
        {filteredEmployees.map((employee) => (
          <div key={employee.id} className="col-lg-4 col-md-6 col-sm-12 mb-4">
            <div className="box h-100">
              <div className="box-body text-center">
                <div className="mb-3">
                  <div className="avatar-circle">
                    {employee.name.split(' ').map(n => n[0]).join('')}
                  </div>
                </div>
                
                <h5 className="card-title mb-1">{employee.name}</h5>
                <p className="text-primary mb-1">{employee.title}</p>
                <p className="text-muted mb-3">{employee.department}</p>
                
                <div className="contact-info text-start">
                  <div className="d-flex align-items-center mb-2">
                    <i className="bx bx-envelope text-muted me-2"></i>
                    <small>{employee.email}</small>
                  </div>
                  <div className="d-flex align-items-center mb-2">
                    <i className="bx bx-phone text-muted me-2"></i>
                    <small>{employee.phone}</small>
                  </div>
                  <div className="d-flex align-items-center mb-3">
                    <i className="bx bx-map text-muted me-2"></i>
                    <small>{employee.location}</small>
                  </div>
                </div>
                
                <div className="d-grid gap-2 d-md-flex justify-content-md-center">
                  <button 
                    className="btn btn-primary btn-sm"
                    onClick={() => {
                      setSelectedEmployee(employee);
                      setIsModalOpen(true);
                    }}
                  >
                    <i className="bx bx-info-circle me-1"></i>
                    Detayları Gör
                  </button>
                  <button 
                    className="btn btn-outline-primary btn-sm"
                    onClick={() => {
                      window.location.href = `mailto:${employee.email}`;
                    }}
                  >
                    <i className="bx bx-message me-1"></i>
                    Mesaj Gönder
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* No Results */}
      {filteredEmployees.length === 0 && (
        <div className="row">
          <div className="col-12">
            <div className="box">
              <div className="box-body text-center py-5">
                <i className="bx bx-user-x display-1 text-muted mb-3"></i>
                <h4>Arama kriterlerine uygun çalışan bulunamadı</h4>
                <p className="text-muted">Lütfen arama terimlerinizi değiştirip tekrar deneyin.</p>
                <button 
                  className="btn btn-primary"
                  onClick={() => {
                    setSearchQuery('');
                    setSelectedDepartment('Tümü');
                  }}
                >
                  Filtreleri Temizle
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Employee Detail Modal */}
      <EmployeeDetailModal 
        employee={selectedEmployee}
        isOpen={isModalOpen}
        onClose={() => {
          setIsModalOpen(false);
          setSelectedEmployee(null);
        }}
      />
    </div>
  );
};

export default DirectoryPage; 